import { useCallback, useEffect, useRef, useState } from 'react';

export function useTimeout(callback: () => void, delay: number | null, enable = true) {
  const timeoutRef = useRef<number | null>(null);
  const savedCallback = useRef(callback);
  const [id, setId] = useState(1);

  const reset = useCallback(() => {
    setId((oldId) => oldId + 1);
  }, []);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enable) return;

    const tick = () => {
      savedCallback.current();
    };
    if (typeof delay === 'number' && delay >= 0) {
      timeoutRef.current = window.setTimeout(tick, delay);
      return () => {
        if (timeoutRef.current) {
          window.clearTimeout(timeoutRef.current);
        }
      };
    }
  }, [delay, id, enable]);

  return { timeoutRef, reset };
}
